import { deserialize, fetchWrapper } from '../fetch';
import type { WikiPage } from './interface';

export const KNOWLEDGE_PREFIX = 'knowledge/';

export const fetchWikiPage = async (
  dossierId: string,
  path: string
): Promise<WikiPage> => {
  const isKnowledge = path.startsWith(KNOWLEDGE_PREFIX);
  const segment = isKnowledge ? 'knowledge' : 'wiki';
  const url = new URL(
    `/app/v1/dossiers/${dossierId}/${segment}/page`,
    API_BASE_URL
  );
  url.searchParams.set('path', path);
  return deserialize(
    await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
  );
};
